import React, { createContext, useCallback, useContext, useRef, useState } from 'react';
import { useStore } from 'react-redux';
import PromoLeaveConfirmModal from '../components/PromoForm/PromoLeaveConfirmModal';
import { hasPromoFormDraft } from '../utils/promoFormDraft';

const PromoLeaveGuardContext = createContext(null);

export function PromoLeaveGuardProvider({ children }) {
    const store = useStore();
    const [isOpen, setIsOpen] = useState(false);
    const pendingActionRef = useRef(null);

    const requestLeave = useCallback((action) => {
        if (!hasPromoFormDraft(store.getState())) {
            action();
            return;
        }
        pendingActionRef.current = action;
        setIsOpen(true);
    }, [store]);

    const handleConfirm = useCallback(() => {
        const action = pendingActionRef.current;
        pendingActionRef.current = null;
        setIsOpen(false);
        action?.();
    }, []);

    const handleCancel = useCallback(() => {
        pendingActionRef.current = null;
        setIsOpen(false);
    }, []);

    return (
        <PromoLeaveGuardContext.Provider value={{ requestLeave }}>
            {children}
            <PromoLeaveConfirmModal
                isOpen={isOpen}
                onConfirm={handleConfirm}
                onCancel={handleCancel}
            />
        </PromoLeaveGuardContext.Provider>
    );
}

export function usePromoLeaveGuard() {
    const context = useContext(PromoLeaveGuardContext);
    if (!context) {
        throw new Error('usePromoLeaveGuard must be used within PromoLeaveGuardProvider');
    }
    return context;
}
